import * as React from "react";
import {useDispatch, useSelector} from "react-redux";
import {setConversionOutput} from "../../slices/sourceCodeSlice";
import {getActivePage} from "../../slices/tableSlice";
import {tableStateToMatrix2d} from "../../misc/matrix2d";
import {selectRules} from "../../slices/ruleSlice";
import {v4 as uuid} from 'uuid';

export interface ConvertImmediateFormatButtonProps{

}


export function ToImmediateFormatButton(props: React.PropsWithChildren<ConvertImmediateFormatButtonProps>){

    const tableData = useSelector(getActivePage)
    const rules = useSelector(selectRules)
    const dispatch = useDispatch()
    const[isLoading, setLoading] = React.useState(false)

    const runExtraction = async (evt: React.MouseEvent)=>{
        try{
            setLoading(true)

            const url = "/converter/convertMatrix2dToImmediateFormat"
            let xReqId = uuid()
            const response = await fetch(url,{
                method:"POST",
                body: JSON.stringify({
                    "matrix2d":tableStateToMatrix2d(tableData),
                    "rules": rules
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'x-request-id': xReqId
                }
            })
            const responseData = await response.json()

            dispatch(setConversionOutput(JSON.stringify(responseData, null, 2)))
        }catch (e) {
            console.log(e)
        }


        setLoading(false)
    }

    if(isLoading){
        return <span>Bitte warten, wird geladen...</span>
    }

    return <button onClick={runExtraction}>
        TBL 2 IF
    </button>
}